import { ElementType, lazy } from "react";
// TODO: Add lazy loading of each page element when development is complete

import AdminLogin from "../pages/Admin/Auth/Login";
import Dashboard from "../pages/Admin/Dashboard/Dashboard";
import InvoiceList from "../pages/Admin/Invoice/InvoiceList";
import ManageInvoice from "../pages/Admin/Invoice/ManageInvoice";
import PaymentList from "../pages/Admin/Invoice/PaymentList";
import WaitingForApprovalList from "../pages/Admin/Invoice/WaitingForApprovalList";
import WaitingForPaymentList from "../pages/Admin/Invoice/WaitingForPaymentList";
import ManageVendor from "../pages/Admin/Vendor/ManageVendor";
import VendorDetails from "../pages/Admin/Vendor/VendorDetails";
import VendorList from "../pages/Admin/Vendor/VendorList";
import KeycloakSignIn from "../pages/Auth/KeycloakSignIn";
import { TUserRoles, USER_ROLES } from "../types/global.type";
const NotFound = lazy(() => import("../pages/NotFound"));
// const SignIn = lazy(() => import("../pages/auth/SignIn"));

export interface RouteType {
  path: string;
  element: ElementType;
  roles: TUserRoles[];
  name?: string;
}

// auth routers
export const sidebarRouters: RouteType[] = [
  // admin
  {
    path: "/admin/dashboard",
    element: Dashboard,
    roles: [USER_ROLES.ADMIN],
  },

  // ---- Vendor Routes ----
  {
    path: "/admin/vendors",
    element: VendorList,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/vendors/add",
    element: ManageVendor,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/vendors/edit/:id",
    element: ManageVendor,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/vendors/view/:id",
    element: VendorDetails,
    roles: [USER_ROLES.ADMIN],
  },

  // ---- Invoice Routes ----
  {
    path: "/admin/invoices/list",
    element: InvoiceList,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/invoices/waiting-for-approval",
    element: WaitingForApprovalList,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/invoices/waiting-for-payment",
    element: WaitingForPaymentList,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/invoices/payments",
    element: PaymentList,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/invoices/list/add",
    element: ManageInvoice,
    roles: [USER_ROLES.ADMIN],
  },
  {
    path: "/admin/invoices/list/edit/:id",
    element: ManageInvoice,
    roles: [USER_ROLES.ADMIN],
  },
];

// public routers
export const publicRouters: Omit<RouteType, "roles">[] = [
  {
    path: "/admin/login",
    element: AdminLogin,
  },
  {
    path: "/sign-in",
    element: KeycloakSignIn,
  },
  {
    path: "/404",
    element: NotFound,
  },
  {
    path: "*",
    element: NotFound,
  },
];
